import { Stack, Typography, useTheme } from '@chronosphereio/chrono-ui';
import React from 'react';

const HEADER_HEIGHT = '24px';

export type OptionsEditorGroupProps = {
  /**
   * Text that communicates the purpose of the grouping.
   */
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
};

/**
 * Group similar content within panel options.
 */
export const OptionsEditorGroup = ({ title, children, icon }: OptionsEditorGroupProps) => {
  const { theme } = useTheme();
  return (
    <div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        borderBottom={1}
        borderColor={theme.featureFlags.panwRebrandStubYear ? theme.palette.border.default : 'grey.300'}
        marginBottom={1}
        // Ensure that the headers have a consistent height whether or not they include an icon
        height={HEADER_HEIGHT}
        lineHeight={HEADER_HEIGHT}
      >
        <Typography variant="overline2" component="h4">
          {title}
        </Typography>
        {icon}
      </Stack>
      <Stack spacing={1}>{children}</Stack>
    </div>
  );
};
